module.exports = __webpack_public_path__ + "img/authenticationBg.43ad40dc.png";